/*
* Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
*
* Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
* the License. A copy of the License is located at
*
*     http://aws.amazon.com/apache2.0/
*
* or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
* CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
* and limitations under the License.
*/

<template>
  <div id="app">
    <div v-if="currentSession === null">
      <b-col md="6" offset="3" class="login-container" v-if="currentSession === null">
        <div class="logo-container full-width">
          <img src="static/img/basic/boom_logo.png" alt="">
        </div>
      </b-col>
      <amplify-authenticator 
        v-bind:authConfig="authConfig"
        username-alias='email'>
        <amplify-sign-in slot="sign-in">
          <div slot="secondary-footer-content"></div>
        </amplify-sign-in>
      </amplify-authenticator>
    </div>
    <div v-else>
      <template>
        <div class="row">
          <div class="col-lg-2 d-none d-lg-block">
            <sidebar/>
          </div>
          <div class="body col-lg-10 d-lg-block" style="text-align: left" id="page-wrap">
            <router-view/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sidebar from '@/components/common/Sidebar';
  import Header from '@/components/common/Header';
  import SignIn from '@/components/common/SignIn';
  import SearchBar from '@/components/common/SearchBar';
  import NavBar from '@/components/common/NavBar';
  import Loader from '@/components/common/Loader';
  import {Push} from 'vue-burger-menu'
  import Subscribe from '@/components/Subscribe';
  import BootstrapVue, {ButtonPlugin, CardPlugin, ModalPlugin, TablePlugin, TabsPlugin} from 'bootstrap-vue'
  import VueMaterial from 'vue-material'
  import 'vue-material/dist/vue-material.min.css'
  import { Auth, Hub } from 'aws-amplify';
  import vueCountryRegionSelect from 'vue-country-region-select'
  import axios from 'axios'
  import VueSweetalert2 from 'vue-sweetalert2';
  // If you don't need the styles, do not connect
  import 'sweetalert2/dist/sweetalert2.min.css';
  import VueMoment from 'vue-moment'
  import VueTheMask from 'vue-the-mask'
  import VuePhoneNumberInput from 'vue-phone-number-input';
  import 'vue-phone-number-input/dist/vue-phone-number-input.css';
  import VueSwal from 'vue-swal'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import IconsPlugin from 'bootstrap-vue'
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import VueFacebookPixel from 'vue-analytics-facebook-pixel'
   
  // Vue.use(VueFacebookPixel)
  // Vue.analytics.fbq.init('274587910255863')

  // Install BootstrapVue
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
  Vue.use(Loading)
  Vue.use(VueSwal)
  Vue.use(VueTheMask)
  Vue.use(VueMoment)
  Vue.use(VueSweetalert2);
  Vue.use(vueCountryRegionSelect)
  Vue.use(TabsPlugin)
  Vue.use(ModalPlugin)
  Vue.use(ButtonPlugin)
  Vue.use(TablePlugin)
  Vue.use(CardPlugin)
  Vue.use(VueMaterial)
  Vue.component('vue-phone-number-input', VuePhoneNumberInput);
  Vue.component('sidebar', Sidebar)
  Vue.component('app-header', Header)
  Vue.component('sign-in', SignIn)
  Vue.component('loader', Loader)
  Vue.component('search-bar', SearchBar)
  Vue.component('nav-bar', NavBar)
  Vue.component('subscribe', Subscribe)

  window.LOG_LEVEL = 'VERBOSE';

  export default {
    name: 'app',
    data() {
      return {
        enabled: false,
        loggedIn: false,
        pushedLoad: false,
        firstPath: '',
        currentSession: null,
        fields: [
          { type: 'given_name', label: 'First Name', placeholder: 'First name', required: true},
          { type: 'family_name', label: 'Last Name', placeholder: 'First name', required: true},
          { type: 'username', label: 'Email', placeholder: 'Email address', required: true },
          { type: 'password', label: 'Password', placeholder: 'Password', required: true },
          { type: 'custom:business_name', label: 'Business name', placeholder: 'Your business name'},
          { type: 'website', label: 'Website', placeholder: 'http://yoursite.com', required: false},
          { type: 'phone_number', label: 'Phone number', placeholder: '(310) 555-1234', required: true},
        ],
        authConfig: {
          signInConfig: {
            isSignUpDisplayed: false
          }
        }
      }
    },
    computed: {
      isMobile() {
        if (screen.width <= 760) {
          return true;
        } else {
          return false;
        }
      },
    },
    methods: {
      initialAuthState() {
        console.log('route')
        console.log(this.$router)
        const state = this.$router.currentRoute.query.state
        if (state !== undefined) {
          if (state === 'signup') return 'signup'
        }
        return 'signin'
      },
      checkSession() {
        Auth.currentSession()
          .then(data => {
            this.configureAxios(data.idToken)
            console.log("session token")
            console.log(data)
            this.currentSession = data
          })
          .catch(err => {
            console.log(err)
            this.currentSession = null
          });
      },
      configureAxios(data) {
        let self = this;
        axios.interceptors.request.use(
          (config) => {
            let token = data.jwtToken
            config.headers['Authorization'] = `Bearer ${token}`;
            return config;
          },
          function (error) {
            return Promise.reject(error);
          }
        );
        axios.interceptors.response.use(response => {
          return response;
        }, function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            return Promise.reject(error)
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
            return Promise.reject(error)
            // self.checkSession()
            // self.$router.go()
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            return Promise.reject(error)
          }
        });
      }
    },
    components: {
      Push
    },
    updated() {
      if (!this.pushedLoad) {
        console.log("trying to push")
        console.log(this.firstPath)
        this.$router.push(this.firstPath)
        this.pushedLoad = true
      }
    },
    created() {
      this.firstPath = window.location.pathname + window.location.search
      this.checkSession()
    },
    mounted() {
      Auth.currentSession()
        .then(data => {
          this.currentSession = data
        }).catch(err => {
          console.log(err)
        })

      Hub.listen('auth', (data) => {
        const event = data.payload.event
        if (event == 'signIn' || event == 'signOut' || event == 'signUp') {
          this.checkSession()
        }
      })
    }
  }
</script>

<style>
  :root {
    --amplify-primary-color: #28296B;
    --amplify-primary-tint: #28296B;
    --amplify-primary-shade: #e0573e;
    --amplify-font-family: 'Helvetica';
    --primary: #28296B;
  }

  .logo-container {
    padding-top: 36px;
    padding-bottom: 16px;
    text-align: center;
    display: block;
  }

  .logo-container img {
    width: 200px;
  }

  .full-width {
    width: 100%;
  }

  .swal2-container {
    z-index: 10000;
  }

  .container-fluid {
    padding-left: 0px;
    padding-right: 0px;
  }

  .main-sidebar {
    padding-left: 15px
  }

  .bm-burger-bars {
    background-color: #03a9f4;
  }

  .bm-cross-button {
    z-index: 10;
  }

  .line-style {
    position: absolute;
    height: 13%;
    left: 0;
    right: 0;
  }

  .bm-burger-button {
    position: fixed;
    width: 24px;
    height: 20px;
    left: 15px;
    top: 15px;
    cursor: pointer;
    z-index: 10;
  }

  .bm-menu {
    background-color: white;
  }

  body {
    margin: 0;
    background-color: white;
    min-height: 100%;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    text-align: center;
    min-height: 100%;
  }

  h4 {
    font-weight: 400;
    text-align: left;
  }

  h5 {
    font-weight: 400;
    text-align: left;
  }

  .pre {
    background: #f8f8f8
  }

  .container {
    text-align: center;
    margin-left: 30px;
  }

  .shifted {
    text-align: left;
  }

  section {
    margin-top: 30px;
  }

  article {
    margin-top: 30px;
  }

  .lineBreak {
    height: 0;
    border-bottom: 1px solid #ededed;
    margin: 1em 10%;
  }

  .form {
    display: inline-block;
    width: 320px;
  }

  inputRow {
    display: block;
    margin-top: 0.5em;
  }

  .input {
    width: 100%;
    font-size: 1em;
    padding: 0.5em;
    box-sizing: border-box;
    outline: none;
    border: none;
    border-bottom: 2px solid #2196F3;
  }

  .inputLabel {
    display: block;
    text-align: left;
  }

  .actionRow {
    display: flex;
    margin-top: 0.5em;
    text-align: right;
  }

  .action {
    font-size: 1em;
    border: none;
    outline: none;
    padding: 12px 50px;
    background-color: #ededed;
    cursor: pointer;
  }

  .footer {
    margin-top: 1em;
  }

  .footerLeft {
    float: left;
  }

  .footerRight {
    float: right;
  }

  .link {
    text-decoration: underline;
    cursor: pointer;
  }

  .error {
    background: orange;
    padding: 0.5em;
  }

  .nav {
    margin-bottom: 1em;
    display: flex;
    justify-content: space-between;
    background-color: #2196F3;
    color: #fff;
    padding: 1em;
  }

  .item {
    font-weight: 500;
    padding: 0 0.5em;
    cursor: pointer;
  }

  .nav > .greeting {
    font-weight: 500;
    color: #000;
    padding: 0 0.5em;
  }

  .nav > .main {
    flex-grow: 1;
    text-align: left;
  }

  .nav > .right {
    font-size: 0.8em;
  }

  .avatar {
    max-height: 150px;
  }

  .avatar-pic {
    max-height: 100px;
  }

  /* accordion */
  .message {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }

  .message-header {
    cursor: pointer;
  }

  .message-body {
    padding: 0;
    max-height: 50em;
    width: 100%;
    overflow: hidden;
    transition: 0.3s ease all;
  }

  .is-closed .message-body {
    max-height: 0;
  }

  .is-primary .arrow {
    transform: rotateZ(90deg) translatex(-5px);

  }

  .arrow {
    display: inline-block;
  }


  .message-content {
    padding: 20px;
  }

  .brand-purple {
    background: #28296B;
  }

  .brand-teal {
    background: #63E7CD;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue